import { StatusIndicatorProps } from '@cloudscape-design/components';
import { TaskStatus } from '@amzn/gbsa-helios-typescript-client';

export { TaskStatus } from '@amzn/gbsa-helios-typescript-client';

export const TASK_STATUS_COLORS: Record<string, StatusIndicatorProps.Type> = {
  [TaskStatus.ASSIGNED]: 'pending',
  [TaskStatus.IN_PROGRESS]: 'in-progress',
  [TaskStatus.COMPLETED]: 'success',
  [TaskStatus.CANCELLED]: 'error',
  [TaskStatus.OVERDUE]: 'error',
  EXPIRED: 'stopped',
};

export const TASK_STATUS_COLOR_OVERRIDE: Record<string, StatusIndicatorProps.Color> = {
  [TaskStatus.ASSIGNED]: 'grey',
  [TaskStatus.IN_PROGRESS]: 'blue',
  [TaskStatus.COMPLETED]: 'green',
  [TaskStatus.CANCELLED]: 'red',
  EXPIRED: 'red',
};

export const getTaskStatusType = (status: string): StatusIndicatorProps.Type => {
  const upperStatus = status.toUpperCase();
  return TASK_STATUS_COLORS[upperStatus] || 'pending';
};

export const TASK_STATUS_LABELS: Record<string, string> = {
  [TaskStatus.ASSIGNED]: 'Assigned',
  [TaskStatus.IN_PROGRESS]: 'In Progress',
  [TaskStatus.COMPLETED]: 'Completed',
  [TaskStatus.CANCELLED]: 'Cancelled',
  [TaskStatus.DRAFT]: 'Draft',
  EXPIRED: 'Expired',
  [TaskStatus.OVERDUE]: 'Overdue',
};

export const getTaskStatusColor = (status: string): StatusIndicatorProps.Color => {
  const upperStatus = status.toUpperCase();
  return TASK_STATUS_COLOR_OVERRIDE[upperStatus] || 'grey';
};

export const getTaskStatusLabel = (status: string): string => {
  const upperStatus = status.toUpperCase();
  return TASK_STATUS_LABELS[upperStatus] || status;
};
